<section
  class="col-lg-11 col-xxl-9 mx-auto d-flex flex-column justify-content-center align-items-center h-100 gap-3">
  <figure>
    <img
      src="/images/logo/ihela-ryanje.png"
      class="opacity-50 ihela-ryanje-logo"
      alt="Logo" />
  </figure>
  <h1 class="text-capitalize text-secondary mt-3">
    IHela ryanje
    @if (typeMenu()) {
      /
    }
    {{ typeMenu() }}
  </h1>
  <div class="d-flex flex-wrap gap-4 mt-3 justify-content-center">
    @for (menu of menus(); track $index) {
      <div
        class="d-flex justify-content-start align-items-center gap-3 py-3 px-3 menu-card bg-input lg-radius bg-hover-white">
        <span>
          <i class="fa-solid fa-{{ menu.icon }} fa-xl text-secondary"></i>
        </span>
        <span class="fs-medium text-dark"> {{ menu.title }} </span>
      </div>
    }
    <div class="menu-card"></div>
    <div class="menu-card"></div>
  </div>
</section>
